var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 19.3332L18.5117 21.4598C17.3034 23.7798 14.8746 25.3748 12.0834 25.3748C8.08379 25.3748 4.83337 22.1244 4.83337 18.1248C4.83337 15.1886 6.59754 12.6873 9.12296 11.5394L9.37671 14.1615C8.10796 15.0315 7.25004 16.4694 7.25004 18.1248C7.25004 20.7953 9.41296 22.9582 12.0834 22.9582C14.3309 22.9582 16.2038 21.4115 16.7475 19.3332H16.9167ZM23.623 19.4661L22.1125 20.2153L18.7292 15.7082H13.183L12.9413 13.2915H16.9167V10.8748H12.6875L12.325 7.24984C13.5455 7.10484 14.5 6.08984 14.5 4.83317C14.5 4.19223 14.2454 3.57754 13.7922 3.12433C13.339 2.67112 12.7243 2.4165 12.0834 2.4165C11.4424 2.4165 10.8277 2.67112 10.3745 3.12433C9.92132 3.57754 9.66671 4.19223 9.66671 4.83317V4.954L10.9959 18.1248H17.5209L21.3875 23.2844L24.7105 21.629L23.623 19.4661Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.3dcaf19a94ccf5ee6d26022d4580e8c2.svg";
export { ForwardRef as ReactComponent };